import React from 'react';
import { RichText } from '@fiverr-private/cms_ui';
import { default as MediaAsset } from '@fiverr-private/cms_ui/src/content_types/MediaAsset/component/MediaAsset';

import { getEmbeddedComponents } from '../../constants';
import styles from './styles.module.scss';

// eslint-disable-next-line react/prop-types
export const HeroBanner = ({ media, description, backgroundColor }) => (
    <div className={styles.heroBannerContainer} style={{ backgroundColor }}>
        <div className={styles.media}>
            <MediaAsset {...media} />
        </div>
        <div className="page-container">
            <div className={styles.heroBannerContainerContent}>
                {description && <RichText {...description} embeddedComponents={getEmbeddedComponents()} />}
            </div>
        </div>
    </div>
);
